import { useState, useEffect } from 'react'

/**
 * Detecta se a viewport é mobile (≤768px).
 * Usa matchMedia para reatividade sem re-render excessivo.
 * 
 * "Responsive design is not just about adjustable screen resolutions 
 *  and images, but rather about an entirely different way of thinking."
 *  — Jeffrey Zeldman
 */
export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth <= breakpoint
  )

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint}px)`)
    const handler = (e) => setIsMobile(e.matches)
    
    mql.addEventListener('change', handler)
    setIsMobile(mql.matches)
    
    return () => mql.removeEventListener('change', handler)
  }, [breakpoint])

  return isMobile
}
